import React from "react";

import FilterIcon from "@uui/FilterLines";

import { Button, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import styled from "@mui/material/styles/styled";

import { FloatingNavButton } from "@app/analytics/components/reports/FloatingNav";
import { FilterCount } from "@app/analytics/MeetingReport/styles";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import Menu, { MenuHeader } from "@rui/Menu";
import { Column, Row } from "@rui/Stack";
import TooltipWrapper from "@rui/TooltipWrapper";

import SpeakerFilters from "./SpeakerFilters";

const Indicator = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.shades.primary[500],
  height: "6px",
  width: "6px",
  borderRadius: "50%",
}));

const TranscriptFiltersButtonAndMenu = ({
  filterCount,
  onClearFilters,
}: {
  filterCount: number;
  onClearFilters: () => void;
}) => {
  const { anchorEl, onClick, open, onClose } = useAnchorElement();

  const hasFilters = filterCount > 0;

  return (
    <>
      <TooltipWrapper placement="bottom" title="Filter transcript">
        <FloatingNavButton
          Icon={() => (
            <>
              <FilterIcon />
              {hasFilters && <FilterCount>{filterCount}</FilterCount>}
            </>
          )}
          onClick={onClick}
          active={open}
          sx={{ width: hasFilters ? "fit-content" : undefined }}
        >
          Filter
        </FloatingNavButton>
      </TooltipWrapper>
      <Menu
        open={open}
        onClose={onClose}
        anchorEl={anchorEl}
        disablePadding
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuHeader variant="apart">
          <Row spacing={1} alignItems="center">
            <FilterIcon />
            <span>Filters</span>
            {hasFilters && <FilterCount>{filterCount}</FilterCount>}
          </Row>
          {hasFilters && (
            <Button onClick={onClearFilters} sx={{ p: "2px 4px" }}>
              Clear all
            </Button>
          )}
        </MenuHeader>
        <Column padding={2} spacing={1} minWidth="300px">
          <Row alignItems="center" spacing={1}>
            <Typography>Speakers</Typography>
            {hasFilters && <Indicator />}
          </Row>
          <SpeakerFilters />
        </Column>
      </Menu>
    </>
  );
};

export default TranscriptFiltersButtonAndMenu;
